import React, { Component } from "react";

import { Table, message, Divider, Modal, Input, Button, Popconfirm } from "antd";

import api from "../../../services/api";
//import handleError from "../../../services/apiErrorHandler";
//import 'antd/dist/antd.css';

export default class ListagemModelo extends React.Component {

    state = {
        spin: true,
        dataSource: [],
        showModal: false
    }

    componentDidMount() {

        this.getModelos()
    }

    getModelos = async () => {
        try {
            let res = await api.get('/sms/modelo_sms/')
            let dataSource = []
            res.data.map(value => {
                dataSource.push({
                    modelo: value.texto,
                    id: value.id
                })
            })
            this.setState({
                spin: false,
                dataSource: dataSource
            })
        } catch (err) {
            message.error('Ocorreu um erro!')
            console.log(err)
            this.setState({
                spin: false,
                dataSource: []
            })
        }
    }

    columns = [
        {
            title: 'Modelo',
            dataIndex: 'modelo',
            key: 'modelo',
        }, {
            title: 'Ação',
            key: 'action',
            render: (text, record) => (
                <span>
                    <Button type="primary" onClick={() => {
                        this.handleUpdateClick(record)
                    }}>Update</Button>
                    <Divider type="vertical" />
                    <Button onClick={() => this.delete(record)} type="danger">
                        Deletar
                    </Button>
                </span>
            ),
        },
    ]

    delete = async record => {
        const { confirm } = Modal;
        const getModelos = this.getModelos
        confirm({
            title: 'Tem certeza que deseja deletar esse modelo?',
            async onOk() {
                try {
                    console.log(record.id)
                    let res = await api.delete(`/sms/modelo_sms/${record.id}/`)
                    message.error('Modelo deletado com sucesso')
                    getModelos()
                } catch (err) {
                    console.log(err)
                    message.error('Ocorreu um erro')
                }

            },
            onCancel() { },
        });
    }

    handleUpdateClick = (record) => {
        this.setState({
            ...this.state,
            showModal: true,
            modelo: record
        });
        console.log(this.state);
    }

    closeModal = () => {
        this.setState({
            ...this.state,
            showModal: false
        })
    }

    update = async e => {
        const texto = document.getElementById('texto').value
        if (texto == '') {
            message.error('Digite o modelo')
            return
        }
        try {
            let res = await api.put(`/sms/modelo_sms/${this.state.modelo.id}/`, {
                texto: texto, user: localStorage.auth_userid
            })
            message.success('Modelo atualizado com sucesso')
            this.getModelos()
            this.closeModal()
        } catch (err) {
            console.log(err)
            message.error('Ocorreu um erro')
        }

    }

    getModalUpdate = (modelo) => {
        return (
            <Modal title="Update Modelo" visible={this.state.showModal} closable={false} footer={[
                <Button type='primary' onClick={this.update}>Salvar</Button>
                ,
                <Button type='danger' onClick={this.closeModal}>Cancelar</Button>
            ]}>
                <Input.TextArea defaultValue={modelo.modelo} id="texto" /><br />

            </Modal>
        )
    }




    render() {

        let modal = this.state.showModal == true ? this.getModalUpdate(this.state.modelo) : ''


        return (
            <React.Fragment>
                <br />
                <Table
                    loading={this.state.spin}
                    columns={this.columns}
                    dataSource={this.state.dataSource}
                />
                {modal}
            </React.Fragment>
        )
    }

}


// WEBPACK FOOTER //
// ./src/pages/Sms/ListagemModelo/index.js